import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ChevronLeft, Pencil, Loader2 } from "lucide-react";
import { warehouseService } from "../../../services/warehouse.service";

function Field({ label, value }) {
  return (
    <div className="rounded-[12px] border border-slate-200 bg-white p-4">
      <div className="text-[12px] font-semibold text-slate-400">{label}</div>
      <div className="mt-1 text-[14px] font-semibold text-slate-700">
        {value || "-"}
      </div>
    </div>
  );
}

export default function WarehouseView() {
  const nav = useNavigate();
  const { id } = useParams();

  const [state, setState] = useState({
    loading: true,
    error: "",
    data: null,
  });

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        setState({ loading: true, error: "", data: null });
        const res = await warehouseService.getWarehouse(id);

        // support common API shapes
        const w =
          res?.warehouse ||
          res?.data?.warehouse ||
          res?.item ||
          res?.data ||
          res;

        if (!alive) return;
        setState({ loading: false, error: "", data: w });
      } catch (e) {
        if (!alive) return;
        setState({
          loading: false,
          error: e?.message || "Failed to load warehouse",
          data: null,
        });
      }
    })();

    return () => {
      alive = false;
    };
  }, [id]);

  const w = state.data;

  return (
    <div className="w-full">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => nav(-1)}
            className="inline-flex h-[38px] items-center gap-2 rounded-full border border-[#f2c6cc] bg-white px-4 text-[13px] font-semibold text-[#d86a78] hover:bg-[#fff5f7]"
          >
            <ChevronLeft size={18} />
            Back
          </button>

          <h1 className="text-[22px] font-bold tracking-wide text-[#d86a78]">
            WAREHOUSE DETAILS
          </h1>
        </div>

        <button
          type="button"
          disabled={state.loading || !w?.id}
          onClick={() => nav(`/admin/dashboard/warehouse/${id}/edit`)}
          className="inline-flex h-[38px] items-center gap-2 rounded-full bg-[#d86a78] px-6 text-[13px] font-semibold text-white hover:bg-[#c95b69] disabled:opacity-60"
        >
          <Pencil size={16} />
          Edit Warehouse
        </button>
      </div>

      <div className="mt-6 rounded-[14px] border border-slate-200/70 bg-white p-5">
        {state.loading ? (
          <div className="flex items-center gap-2 text-slate-500">
            <Loader2 className="animate-spin" size={18} />
            Loading warehouse...
          </div>
        ) : state.error ? (
          <div className="text-[13px] font-semibold text-rose-600">
            {state.error}
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
            <Field label="Warehouse Name" value={w?.name} />
            <Field label="Status" value={w?.status} />
            <Field label="Manager" value={w?.manager_name || w?.manager} />
            <Field label="Email" value={w?.email} />
            <Field label="Phone" value={w?.phone} />
            <Field label="City" value={w?.city} />
            <Field label="State" value={w?.state} />
            <Field label="Address" value={w?.address} />
            <Field label="Pincode" value={w?.pincode || w?.zip} />
          </div>
        )}
      </div>
    </div>
  );
}